import { z } from 'zod';

export const PapelSchema = z.enum(['ADMINISTRADOR', 'COLABORADOR', 'VISUALIZADOR']);

export const ConvidarMembroSchema = z.object({
  email: z.string().email(),
  papel: PapelSchema,
});

export const AceitarConviteSchema = z.object({
  token: z.string().min(32),
});

export const MembroDtoSchema = z.object({
  id: z.string(),
  userId: z.string(),
  nome: z.string().nullable(),
  email: z.string(),
  papel: PapelSchema,
  criadoEm: z.string(),
});

export const ConviteDtoSchema = z.object({
  id: z.string(),
  email: z.string(),
  papel: PapelSchema,
  expiresAt: z.string(),
  criadoEm: z.string(),
});

export const MembrosResponseSchema = z.object({
  membros: z.array(MembroDtoSchema),
  convitesPendentes: z.array(ConviteDtoSchema),
});

export const SwitchEmpresaSchema = z.object({ empresaId: z.string() });

export const EmpresaSubsetSchema = z.object({
  id: z.string(),
  razaoSocial: z.string(),
  papel: PapelSchema,
});
export const MinhasEmpresasResponseSchema = z.object({
  empresas: z.array(EmpresaSubsetSchema),
  activeEmpresaId: z.string().nullable(),
});

export type Papel = z.infer<typeof PapelSchema>;
export type ConvidarMembro = z.infer<typeof ConvidarMembroSchema>;
export type AceitarConvite = z.infer<typeof AceitarConviteSchema>;
export type MembroDto = z.infer<typeof MembroDtoSchema>;
export type ConviteDto = z.infer<typeof ConviteDtoSchema>;
export type MembrosResponse = z.infer<typeof MembrosResponseSchema>;
export type SwitchEmpresa = z.infer<typeof SwitchEmpresaSchema>;
export type EmpresaSubset = z.infer<typeof EmpresaSubsetSchema>;
export type MinhasEmpresasResponse = z.infer<typeof MinhasEmpresasResponseSchema>;
